import { useEffect, useState } from "react";
import Container from "react-bootstrap/Container";
import Row from "react-bootstrap/Row";
import Col from "react-bootstrap/Col";
import { Link, useNavigate } from "react-router-dom";
import "./Footer.scss";
import { FaFacebook, FaInstagram, FaTelegram, FaWhatsapp } from "react-icons/fa";
import Button from "react-bootstrap/Button";
import Modal from "react-bootstrap/Modal";
import Cookies from "js-cookie";

import { useTranslation } from "react-i18next";
import { Image } from "react-bootstrap";

const Footer = () => {
  const { t } = useTranslation(["common","footer"]);

  const navigate = useNavigate();
  const [currentYear] = useState(new Date().getFullYear());

  const [show, setShow] = useState(true);
  const handleClose = () => setShow(false);

  const [isChecked, setIsChecked] = useState(false);

  const handleCheckboxChange = (event) => {
    setIsChecked(event.target.checked);
  };

  const [tokenexist, setTokenexist] = useState(false);

  const [hide, setHide] = useState(false);
  const hideInstaAlert = () => {
    setHide(true);
    Cookies.set("showCookieNotify", "set", {
      expires: 30,
    });

    if (isChecked) {
      Cookies.set("allowCookieTranslate", "set", {
        expires: 1,
      });
    }

    if (isChecked) {
      Cookies.set("allowCookieAnalytics", "set", {
        expires: 30,
      });
    }
  };

  const GetCookie = () => {
    setTokenexist(Cookies.get("showCookieNotify"));
  };

  useEffect(() => {
    GetCookie();
  }, []);

  return (
    <div id="Footer">
      <Container>
        <Row>
          <Col sm={12} md={6} lg={3}>
            <div className="MainFooterInfo">
              <img src={"/images/cleverdomizil-footer-logo.webp"} className="Logo" alt={t('footer:company.image_alt')} onClick={() => navigate("/")} style={{ cursor: "pointer" }} />
              <p>{t('footer:company.description', { postProcess: 'reactNewlineToBr' })}</p>
              <ul>
                <li>
                  <a href="https://www.facebook.com/people/CleverDomizil/61558857249140/" target="_blank" rel="noreferrer" title="Facebook" style={{ color: "#fff" }}>
                    <FaFacebook />
                  </a>
                </li>
                <li>
                  <a href="https://www.instagram.com/cleverdomizil/?igsh=M2dvNnQzbjdibWh0&utm_source=qr" target="_blank" rel="noreferrer" title="Instagram" style={{ color: "#fff" }}>
                    <FaInstagram />
                  </a>
                </li>
                <li>
                  <a href="https://t.me/cleverdomizil" target="_blank" rel="noreferrer" style={{ color: "#fff" }} title="Telegram">
                    <FaTelegram />
                  </a>
                </li>
                <li>
                  <a href="https://api.whatsapp.com/message/WMW2NPRW65XDK1" target="_blank" rel="noreferrer" style={{ color: "#fff" }} title="WhatsApp Chat">
                    <FaWhatsapp />
                  </a>
                </li>
              </ul>
            </div>
          </Col>
          <Col sm={12} md={6} lg={3}>
            <div className="MainFooterLink">
              <h3>{t('footer:information')}</h3>
              <ul>
                <li>
                  <Link to="/">{t('footer:link_1')}</Link>
                </li>
                <li>
                  <Link to="/standorte">{t('footer:link_2')}</Link>
                </li>
                <li>
                  <Link to="/preise">{t('footer:link_3')}</Link>
                </li>
                <li>
                  <Link to="/ueber-uns">{t('footer:link_4')}</Link>
                </li>
                <li>
                  <Link to="/kontakt">{t('footer:link_5')}</Link>
                </li>
                <li>
                  <Link to="/terms">{t('footer:link_6')}</Link>
                </li>
                <li>
                  <Link to="/privacy">{t('footer:link_7')}</Link>
                </li>
                <li>
                  <Link to="/imprint">{t('footer:link_8')}</Link>
                </li>
              </ul>
            </div>
          </Col>
          <Col sm={12} md={6} lg={3}>
            <Row>
              <Col sm={12} xl={4}>
                <Row>
                  <Col sm={12} lg={6} xl={12}>
                    <Image src={"/images/payment/mastercard-logo.svg"} alt={t('footer:payment.image_alt_mastercard')}/>
                  </Col>
                  <Col sm={12} lg={6} xl={12}>
                    <Image src={"/images/payment/visa-logo.svg"} alt={t('footer:payment.image_alt_visa')}/>
                  </Col>
                  <Col sm={12} lg={6} xl={12}>
                    <Image src={"/images/payment/amex-logo.svg"} alt={t('footer:payment.image_alt_amex')}/>
                  </Col>
                  <Col sm={12} lg={6} xl={12}>
                    <Image src={"/images/payment/paypal-logo.svg"} alt={t('footer:payment.image_alt_paypal')}/>
                  </Col>
                </Row>
              </Col>
              <Col sm={12} xl={8}>
                <Row>
                  <Col sm={12}>
                    <Link to={"https://play.google.com/store/apps/details?id=com.cleverdomizilmail"}>
                      <Image
                        src={"/images/cleverdomizil-google-play-virtuelles-buero-app.svg"}
                        alt={t('footer:app.image_alt_google')}
                      />
                    </Link>
                  </Col>
                  <Col sm={12}>
                    <Link to={"https://apps.apple.com/in/app/cleverdomicile/id6502281781"}>
                      <Image
                        src={"/images/cleverdomizil-appstore-virtuelles-buero-app.svg"}
                        alt={t('footer:app.image_alt_apple')}
                      />
                    </Link>
                  </Col>
                </Row>
              </Col>
            </Row>
          </Col>
          <Col sm={12} md={6} lg={3}>
            <div className="MainFooterInfo">
              <h2>{t('footer:contact.heading')}</h2>
              <p>{t('footer:contact.description', { postProcess: 'reactNewlineToBr' })}</p>
            </div>
          </Col>
        </Row>
        <Row>
          <Col sm={12} md={12} lg={12}>
            <p style={{ textAlign: "center", color: "#fff", margin: "20px", marginBottom: "0", fontSize: "14px" }}>{t('footer:tax_text')}</p>
            <div className="MainFooterBottom">
              <p>Copyright &copy; {currentYear} CleverDomizil</p>
            </div>
          </Col>
        </Row>
      </Container>

      {/* Modal of Accept all cookies */}

      {hide ? (
        <></>
      ) : tokenexist ? (
        <></>
      ) : (
        <Modal
          show={show}
          onHide={handleClose}
          backdrop="static"
          keyboard={false}
          aria-labelledby="contained-modal-title-vcenter"
          centered
          size="lg"
          className="CookiesModal"
        >
          <Modal.Header closeButton>
            <Modal.Title id="contained-modal-title-vcenter">
              Datenschutzeinstellungen
            </Modal.Title>
          </Modal.Header>
          <Modal.Body>
            <p>
              Wir verwenden Cookies und andere Tracking-Technologien, die Daten auslesen oder Informationen auf Ihrem Endgerät speichern können. Mit Ihrer
              Einwilligung verarbeiten wir Ihre personenbezogenen Daten zu Analyse- und Optimierungszwecken sowie zu Marketing- und Werbezwecken. Dazu werden
              teilweise Informationen an Dienstleister weitergegeben, die ihren Sitz in einem Drittland haben können, in dem kein vergleichbares
              Datenschutzniveau herrscht. Indem Sie auf "Alle akzeptieren. Cookies“ erklären Sie sich mit dieser Verarbeitung und Übermittlung Ihrer Daten
              einverstanden. Sie können Ihre Einwilligung jederzeit in den Cookie-Einstellungen in der Fußzeile widerrufen. Klicken Sie auf die
              Cookie-Einstellungen, um mehr zu erfahren Weitere Informationen finden Sie in unserer DatenschutzerklärungImpressum
            </p>
            <div className="newDiv">
              <div className="newDivTop">
                <label>
                  <input
                    type="checkbox"
                    checked={true}
                    disabled
                  />
                  Notwendige Cookies
                </label>

                <table>
                  <tbody>
                    <tr>
                      <th>Cookie</th>
                      <th>Ablaufdatum</th>
                    </tr>
                    <tr>
                      <td>PHPSESSID</td>
                      <td>
                        Beim Beenden der Browsersitzung
                      </td>
                    </tr>
                    <tr>
                      <td>ci_session</td>
                      <td>
                        Nach 2 Stunden
                      </td>
                    </tr>
                    <tr>
                      <td>showCookieNotify</td>
                      <td>
                      Nach 30 Tagen
                      </td>
                    </tr>
                    <tr>
                      <td>allowCookieTranslate</td>
                      <td>
                        Nach 30 Tagen
                      </td>
                    </tr>
                    <tr>
                      <td>allowCookieAnalytics</td>
                      <td>
                        Nach 30 Tagen
                      </td>
                    </tr>
                  </tbody>
                </table>
              </div>
              <div className="newDivTop">
                <label>
                  <input type="checkbox" checked={isChecked} onChange={handleCheckboxChange} />
                  Google Übersetzer
                </label>

                <table>
                  <tbody>
                    <tr>
                      <th>Cookie</th>
                      <th>Ablaufdatum</th>
                    </tr>
                    <tr>
                      <td>NID</td>
                      <td>
                        Nach 1 Tag
                      </td>
                    </tr>
                    <tr>
                      <td>__Secure-3PAPISID</td>
                      <td>
                        Nach 1 Tag
                      </td>
                    </tr>
                    <tr>
                      <td>__Secure-3PSID</td>
                      <td>
                        Nach 1 Tag
                      </td>
                    </tr>
                    <tr>
                      <td>__Secure-3PSIDCC</td>
                      <td>
                        Nach 1 Tag
                      </td>
                    </tr>
                  </tbody>
                </table>
              </div>
            </div>
          </Modal.Body>
          <Modal.Footer>
            <Link to="/privacy" className="MOsaveBtn2">
              Mehr Informationen
            </Link>
            
            <Button variant="primary" onClick={() => hideInstaAlert()} className="MOsaveBtn">
              Auswahl akzeptieren
            </Button>
          </Modal.Footer>
        </Modal>
      )}
    </div>
  );
};

export default Footer;
